import type {
  NotificationEventType,
  NotificationEventTypeDto,
} from './notification-event-types.types';

export const mapNotificationEventType = ({
  user_id,
  event_type,
  type,
}: NotificationEventTypeDto): NotificationEventType => ({
  userId: user_id,
  eventType: event_type,
  type,
});
